import { registerRootComponent } from "expo";
import App from "./App";

// Register the root component for Expo
registerRootComponent(App);

// Register service worker for web
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log(
          "Service worker registered with scope:",
          registration.scope
        );

        // 🔹 Listen for updates from service worker
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data?.type === "NEW_VERSION") {
            console.log(`🔄 New version available: ${event.data.version}`);
            window.location.reload();
          }
        });
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  });
}
